import { shape } from "prop-types";
import React, { useEffect, useState } from "react";

const NotificationModal = ({
  isModalOpen,
  toggleModal,
  setNotificationBadge,
}) => {
  //check if its a mobile screen
  const isMobileScreen = window.innerWidth <= 768;

  // Sample notifications data
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      readStatus: false,
      tenant: { profilePicture: "", name: "John Doe" },
      apartment: {
        propertyName: "Kings Palace",
        apartmentNumber: "A1",
        amount: "$200",
      },
      payment: { date: "2024-11-01", status: "pending" },
    },
    {
      id: 2,
      readStatus: false,
      tenant: {
        profilePicture: "https://via.placeholder.com/150",
        name: "Jane Doe",
      },
      apartment: {
        propertyName: "Kings Palace",
        apartmentNumber: "A2",
        amount: "$200",
      },
      payment: { date: "2024-12-04", status: "pending" },
    },
    {
      id: 3,
      readStatus: false,
      tenant: {
        profilePicture: "https://via.placeholder.com/150",
        name: "John Doe",
      },
      apartment: {
        propertyName: "Kings Palace",
        apartmentNumber: "A1",
        amount: "$200",
      },
      payment: { date: "2024-03-01", status: "pending" },
    },
  ]);

  //read notifications
  const [removingNotification, setRemovingNotification] = useState(null);



  useEffect(() => {
    if (notifications.length > 0) {
      const unreadNotifications = notifications.filter(
        (notification) => !notification.readStatus
      );
      setNotificationBadge(unreadNotifications.length);
      console.log(`Notifications length!`, notifications);
    }
  }, notifications);

  //notification hovered
  const [hoveredNotification, setHoveredNotification] = useState(null);

  // Inline styling
  const styles = {
    modalOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.1)",
      // display: "flex",
      // justifyContent: "center",
      // alignItems: "center",
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: "#fff",
      position: "absolute",
      top: isMobileScreen ? "10vh" : "8vh",
      right: isMobileScreen ? "5vw" : "10vw",
      borderRadius: "8px",
      width: isMobileScreen ? "90vw" : "400px",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
      textAlign: "start",
      color: "#192A3A",
    },
    individualNotification: {
     
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      borderRadius: "8px",
      
    
    },
    notificationRemoving: {
      transform: "translateX(100%)",
      opacity: 0,
    },
    individualNotificationHover: {
      transition: "background-color 0.3s, transform 2s, opacity 0.3s",
      backgroundColor: "#f5f5f5",
      cursor: "pointer",

      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderRadius: "8px",
    },
    titleSpace: {
      padding: "10px 15px",
      // backgroundColor: "#192A3A",
      color: "#192A3A",
      fontFamily: "Poppins, sans-serif",
      fontWeight: "500",
      fontSize: "20px",
      textAlign: "center",
    },
    left: {
      display: "flex",
      flexDirection: "row",
      gap: "10px",
      padding: "10px 15px",
    },

    profilePicture: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
    },
    placeHolder: {
      width: "50px",
      height: "50px",
      borderRadius: "50%",
      backgroundColor: "#192A3A",
    },
    closeButton: {
      backgroundColor: "#FF6347",
      color: "#fff",
      border: "none",
      padding: "10px 15px",
      borderRadius: "5px",
      cursor: "pointer",
    },
    nameAndApartment: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "0px",
      fontFamily: "Poppins, sans-serif",
      fontWeight: "300",
    },
    bold: {
      fontWeight: "500",
    },
    date: {
      color: "#9d9d9d",
      fontWeight: "200",
      fontFamily: "Karla, sans-serif",
    },
    right: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "end",
      gap: "10px",
      alignItems: "end",
      color: "#9d9d9d",
      fontWeight: "200",
      fontFamily: "Karla, sans-serif",
      fontSize: "14px",
      padding: "10px 15px",
      height: "100%",
    },
    shape: {
      width: "10px",
      height: "10px",
      borderRadius: "50%",
      backgroundColor: "#192A3A",
    },
    timeSince: {
      textAlign: "end",
    },

    noNotifications: {
      textAlign: "center",
      color: "#888",
      fontSize: "16px",
      padding: "20px",
      fontFamily: "Poppins, sans-serif",
    },
  };
  const handleOverlayClick = (e) => {
    // Close modal only if the click is on the overlay (not the modal content)
    if (e.target === e.currentTarget) {
      toggleModal();
     
    }
  };

  // Function to handle clicking a notification
  const handleNotificationClick = (id) => {
    setRemovingNotification(id); // Start the slide-out animation
    setTimeout(() => {
      // Remove notification after animation
      setNotifications((prevNotifications) =>
        prevNotifications.map((notification) =>
          notification.id === id
            ? { ...notification, readStatus: true }
            : notification
        )
      );
      setRemovingNotification(null); // Reset removingNotification state
    }, 500); // Match this to animation duration
  };


  return (
    <>
      {isModalOpen && (
        <div style={styles.modalOverlay} onClick={handleOverlayClick}>
          <div style={styles.modalContent}>
            <div style={styles.titleSpace}>Your Notifications</div>
            <div style={styles.individualNotification}>
              <div style={{ width: "100%" }}>
                {" "}
                {notifications.filter(notification => !notification.readStatus).length > 0 ? (
                  notifications .filter(notification => !notification.readStatus).map((notification) => {
                    const isRemoving = removingNotification === notification.id;
                    return (
                      <div
                        key={notification.id}
                        style={{
                          ...hoveredNotification === notification.id
                          ? styles.individualNotificationHover
                            : styles.individualNotification,
                            ...(isRemoving && styles.notificationRemoving),
                        }
                        
                        }
                        onMouseEnter={() => {
                          setHoveredNotification(notification.id);
                        }}
                        onMouseLeave={() => {
                          setHoveredNotification(null);
                        }}
                        onClick={() => handleNotificationClick(notification.id)}
                      >
                        <div style={styles.left}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {notification?.tenant?.profilePicture ? (
                              <img
                                style={styles.profilePicture}
                                src={notification?.tenant?.profilePicture}
                                alt={`${notification?.tenant?.name}'s profile`}
                              />
                            ) : (
                              <div style={styles.placeHolder}></div>
                            )}
                          </div>
                          <div style={styles.nameAndApartment}>
                            <div>
                              <span style={styles.bold}>
                                {notification?.tenant?.name}
                              </span>{" "}
                              from {notification?.apartment?.propertyName}
                            </div>
                            <div style={styles.date}>
                              {formatDate(notification?.payment?.date)}
                            </div>
                          </div>
                        </div>
                        <div style={styles.right}>
                          {/* check read status */}
                          {!notification.readStatus ? (
                            <div style={styles.shape}></div>
                          ) : (
                            <></>
                          )}

                          <div style={styles.timeSince}>
                            {timeSince(notification?.payment?.date)}
                          </div>
                        </div>
                      </div>
                    )
                  }
                  )
                ) : (
                  <div style={styles.noNotifications}>No new notifications.</div>
                )}
              </div>
            </div>

            {/* <button style={styles.closeButton} onClick={toggleModal}>
              Close
            </button> */}
          </div>
        </div>
      )}
    </>
  );
};

function formatDate(dateString) {
  const date = new Date(dateString);
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const monthsOfYear = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dayOfWeek = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = monthsOfYear[date.getMonth()];

  const ordinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${dayOfWeek} ${day}${ordinalSuffix(day)} ${month}`;
}

function timeSince(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMilliseconds = now - date;

  const millisecondsInSecond = 1000;
  const millisecondsInMinute = millisecondsInSecond * 60;
  const millisecondsInHour = millisecondsInMinute * 60;
  const millisecondsInDay = millisecondsInHour * 24;
  const millisecondsInMonth = millisecondsInDay * 30;
  const millisecondsInYear = millisecondsInDay * 365;

  const years = Math.floor(diffInMilliseconds / millisecondsInYear);
  const months = Math.floor(diffInMilliseconds / millisecondsInMonth);
  const days = Math.floor(diffInMilliseconds / millisecondsInDay);

  if (years > 0) {
    return `${years} year${years > 1 ? "s" : ""}`;
  } else if (months > 0) {
    return `${months} month${months > 1 ? "s" : ""}`;
  } else if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""}`;
  } else {
    return "Today";
  }
}

export default NotificationModal;
